import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { StoreApi, Permissions } from './types.tsx';

export const setProjectPermissions =
	(projectKey: ProjectKey, permissions: Permissions) =>
	({ setState }: StoreApi): void => {
		setState({
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			[projectKey as string]: permissions,
		});
	};
